var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrgentFlagMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 8.16666C2.91634 8.16666 2.33301 8.75 2.33301 8.75V1.75C2.33301 1.75 2.91634 1.16666 4.66634 1.16666C6.41634 1.16666 7.58301 2.33333 9.33301 2.33333C11.083 2.33333 11.6663 1.75 11.6663 1.75V8.75C11.6663 8.75 11.083 9.33333 9.33301 9.33333C7.58301 9.33333 6.41634 8.16666 4.66634 8.16666Z",
    fill: "#F26C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 8.75C2.33301 8.75 2.91634 8.16666 4.66634 8.16666C6.41634 8.16666 7.58301 9.33333 9.33301 9.33333C11.083 9.33333 11.6663 8.75 11.6663 8.75V1.75C11.6663 1.75 11.083 2.33333 9.33301 2.33333C7.58301 2.33333 6.41634 1.16666 4.66634 1.16666C2.91634 1.16666 2.33301 1.75 2.33301 1.75L2.33301 12.8333",
    stroke: "#F26C0C",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgentFlagMiddle);
export default __webpack_public_path__ + "static/media/urgent_flag_middle.4c747607449fdeacccaaaa39672ffc3e.svg";
export { ForwardRef as ReactComponent };